export const cards = [
  {
    id: 1,
    city: "Chicago",
    time: "",
    gmt: "-5",
    pst: "+2",
    timezone: "America/Chicago",
  },
  {
    id: 2,
    city: "New York",
    time: "",
    gmt: "-4",
    pst: "+3",
    timezone: "America/New_York",
  },
  {
    id: 3,
    city: "Toronto",
    time: "",
    gmt: "-4",
    pst: "+3",
    timezone: "America/Toronto",
  },
  {
    id: 4,
    city: "Sao Paulo",
    time: "",
    gmt: "-3",
    pst: "+4",
    timezone: "America/Sao_Paulo",
  },
  {
    id: 5,
    city: "Lagos",
    time: "",
    gmt: "+1",
    pst: "+8",
    timezone: "Africa/Lagos",
  },
  {
    id: 6,
    city: "London",
    time: "",
    gmt: "+1",
    pst: "+8",
    timezone: "Europe/London",
  },
  {
    id: 7,
    city: "Canton of Zurich",
    time: "",
    gmt: "+2",
    pst: "+9",
    timezone: "Europe/Zurich",
  },
  {
    id: 8,
    city: "Johannesburg",
    time: "",
    gmt: "+2",
    pst: "+9",
    timezone: "Africa/Johannesburg",
  },
  {
    id: 9,
    city: "Paris",
    time: "",
    gmt: "+2",
    pst: "+9",
    timezone: "Europe/Paris",
  },
  {
    id: 10,
    city: "Cairo",
    time: "",
    gmt: "+3",
    pst: "+10",
    timezone: "Africa/Cairo",
  },
  {
    id: 11,
    city: "Istanbul",
    time: "",
    gmt: "+3",
    pst: "+10",
    timezone: "Europe/Istanbul",
  },
  {
    id: 12,
    city: "Moscow",
    time: "",
    gmt: "+3",
    pst: "+10",
    timezone: "Europe/Moscow",
  },
  {
    id: 13,
    city: "Dubai",
    time: "",
    gmt: "+4",
    pst: "+11",
    timezone: "Asia/Dubai",
  },
  {
    id: 14,
    city: "Hong Kong",
    time: "",
    gmt: "+8",
    pst: "+15",
    timezone: "Asia/Hong_Kong",
  },
  {
    id: 15,
    city: "Singapore",
    time: "",
    gmt: "+8",
    pst: "+15",
    timezone: "Asia/Singapore",
  },
  {
    id: 16,
    city: "Shanghai",
    time: "",
    gmt: "+8",
    pst: "+15",
    timezone: "Asia/Shanghai",
  },
  {
    id: 17,
    city: "Tokyo",
    time: "",
    gmt: "+9",
    pst: "+15",
    timezone: "Asia/Tokyo",
  },
  {
    id: 18,
    city: "Sydney",
    time: "",
    gmt: "+10",
    pst: "+16",
    timezone: "Australia/Sydney",
  },
];
